import React, { useEffect, useState } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import $ from "jquery";
import { useSelector } from "react-redux";
import InfoIcon from "../../../../../Images/informationIcon.png";
import TooltipText from "../TooltipText";
import { DisplayMsg } from "../../../../../services/toastService";
import { setUrl } from "../../../../../handlers";

const Services = (props) => {
  const sharedData = useSelector((state) => state.SharedLayoutData);

  const [toggleObj, setToggleObj] = useState(null);

  // const location = useLocation();
  const [detail, setDetail] = useState("");
  const [popup, setPopup] = useState(false);
  const [callToggle, setCallToggle] = useState({
    title: "Service Activation",
    visible: "N",
    flag: "Call_Reminder_Activation",
    HELP_TEXT: "This option turns off Call Reminder service.",
    adv_option_seq_num: null,
    disable: false,
  });
  const [emailToggle, setEmailToggle] = useState({
    title: "Service Activation",
    visible: "N",
    flag: "Email_Remainder_Activation",
    HELP_TEXT: "This option turns off Email Reminder service.",
    adv_option_seq_num: null,
    disable: false,
  });
  const [EmailData, setEmailData] = useState({
    interval: "",
    template: "Default",
    upload: false,
    file: null,
    EmailCheck: "N",
    filePath: "",
    FileErr: false,
  });

  const [CallData, setCallData] = useState({
    interval: "",
    vendor: "West Call Reminder",
    upload: false,
    fileName: null,
    CallCheck: "N",
  });
  const [SaveBtn, setSaveBtn] = useState(true);

  const [Error, setError] = useState({
    EmailErr: "",
    CallErr: "",
    FileErr: "",
  });
  const [reload, setReload] = useState(true);
  const [serviceBtn, setServiceBtn] = useState(true);
  const [Boxes, setBoxes] = useState({
    Visit: "",
    Future: "",
    message: "",
    check: false,
  });
  const [confirm, setConfirm] = useState(false);
  const Templates = [
    {
      label: "Default",
      value: "Default",
    },
    {
      label: "Custom",
      value: "Custom",
    },
  ];

  const Venders = [
    {
      label: "Inhouse Services",
      value: "default",
    },
  ];

  useEffect(() => {
    LoadServicesData();
  }, [props]);

  const DisableToggle = () => {
    if (
      sessionStorage.getItem("type") === "CS" ||
      sessionStorage.getItem("type") === "CSM"
    ) {
      setEmailToggle((toggleInfo) => ({
        ...toggleInfo,
        disable: true,
      }));

      setCallToggle((toggleInfo) => ({
        ...toggleInfo,
        disable: true,
      }));
    }
  };

  const LoadServicesData = async () => {
    const data = new FormData();
    // data.append("seqNum", sessionStorage["ENTITY_SEQ_NUM"]);
    data.append("seqNum", props.entityId);
    data.append("TNSName", sharedData.currentClientTnsName);
    const result = await fetch(setUrl("PRACTICEDETAIL", "LOADSERVICES", true), {
      method: "POST",
      body: data,
    });
    const response = await result.json();
    if (response && response.status) {
      let EmailRemainder = false;
      let CallRemainder = false;
      if (response.EmailReminerData.length > 0) {
        const emailreminder = response.EmailReminerData[0];
        if (
          emailreminder.INTERVAL !== null &&
          emailreminder.INTERVAL !== undefined
        ) {
          setEmailToggle((emailData) => ({
            ...emailData,
            visible: "Y",
            disable: false,
          }));

          setEmailData((emailInfo) => ({
            ...emailInfo,
            EmailCheck: "Y",
            interval: emailreminder.INTERVAL,
          }));

          EmailRemainder = true;
          const binaryString = window.atob(emailreminder.EMAIL_BODY_TEMPLATE);
          const binaryLen = binaryString.length;
          const bytes = new Uint8Array(binaryLen);
          for (let i = 0; i < binaryLen; i++) {
            const ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          const blob = new Blob([bytes], { type: "application/html" });
          const link = window.URL.createObjectURL(blob);
          setEmailData((mailData) => ({
            ...mailData,
            filePath: link,
          }));
          if (
            emailreminder.EMAIL_BODY_TEMPLATE === "(HUGEBLOB)" ||
            emailreminder.EMAIL_BODY_TEMPLATE === "KEhVR0VCTE9CKQ=="
          ) {
            setEmailData((emailInfo) => ({
              ...emailInfo,
              template: "Default",
              file: null,
              upload: false,
            }));
          } else {
            setEmailData((emailInfo) => ({
              ...emailInfo,
              template: "Custom",
              file: null,
              upload: true,
            }));
          }
        } else {
          setEmailToggle((emailData) => ({
            ...emailData,
            visible: "N",
            disable: true,
          }));
          setEmailData((EmailInfo) => ({
            ...EmailInfo,
            EmailCheck: "N",
          }));
        }
      } else {
        setEmailToggle((emailData) => ({
          ...emailData,
          visible: "N",
          disable: true,
        }));
        setEmailData((EmailInfo) => ({
          ...EmailInfo,
          EmailCheck: "N",
          upload: false,
        }));
      }
      if (response.CallReminerData.length > 0) {
        const callreminder = response.CallReminerData[0];
        if (
          callreminder.CALL_REMINDER_INTERVAL_HOURS !== null &&
          callreminder.CALL_REMINDER_INTERVAL_HOURS !== undefined
        ) {
          setCallData((callInfo) => ({
            ...callInfo,
            CallCheck: "Y",
            interval: callreminder.CALL_REMINDER_INTERVAL_HOURS,
          }));
          CallRemainder = true;
          setCallToggle((callData) => ({
            ...callData,
            visible: "Y",
            disable: false,
          }));
        } else {
          setCallToggle((callData) => ({
            ...callData,
            visible: "N",
            disable: true,
          }));

          setCallData((callInfo) => ({
            ...callInfo,
            CallCheck: "N",
          }));
        }
      } else {
        setCallToggle((callData) => ({
          ...callData,
          visible: "N",
          disable: true,
        }));

        setCallData((callInfo) => ({
          ...callInfo,
          CallCheck: "N",
        }));
      }
      if (
        sessionStorage.viewOnly.toUpperCase() === "N" &&
        sessionStorage.type.toUpperCase() === "IT" &&
        sessionStorage.fullAccess.toUpperCase() === "Y"
      ) {
        setCallToggle((callData) => ({
          ...callData,
          disable: false,
        }));

        setSaveBtn(true);

        setEmailToggle((callData) => ({
          ...callData,
          disable: false,
        }));

        if (CallRemainder === false) {
          setCallToggle((callData) => ({
            ...callData,
            visible: "N",
            disable: true,
          }));
          setCallData((callInfo) => ({
            ...callInfo,
            CallCheck: "N",
          }));
        }

        if (EmailRemainder === false) {
          setEmailToggle((callData) => ({
            ...callData,
            visible: "N",
            disable: true,
          }));

          setEmailData((EmailInfo) => ({
            ...EmailInfo,
            EmailCheck: "N",
          }));
        }
      } else if (
        sessionStorage.viewOnly.toUpperCase() === "N" &&
        sessionStorage.type.toUpperCase() === "M" &&
        sessionStorage.fullAccess.toUpperCase() === "Y"
      ) {
        setCallToggle((callData) => ({
          ...callData,
          disable: false,
        }));

        setEmailToggle((callData) => ({
          ...callData,
          disable: false,
        }));
        setServiceBtn(true);
      } else {
        setCallToggle((callData) => ({
          ...callData,
          disable: true,
        }));

        setCallToggle((callData) => ({
          ...callData,
          disable: true,
        }));
        setSaveBtn(false);
      }
    } else {
      setCallToggle((callData) => ({
        ...callData,
        visible: "N",
        disable: true,
      }));

      setCallData((callInfo) => ({
        ...callInfo,
        CallCheck: "N",
      }));

      setEmailToggle((callData) => ({
        ...callData,
        visible: "N",
        disable: true,
      }));

      setEmailData((callInfo) => ({
        ...callInfo,
        EmailCheck: "N",
      }));
    }

    if (
      sessionStorage.type.toUpperCase() !== "IT" &&
      sessionStorage.type.toUpperCase() !== "M"
    ) {
      setSaveBtn(false);
    }
    setReload(false);
    DisableToggle();
  };

  const ConfigrationSetup = (item, type) => {
    const isChecked = item.visible === "Y";

    return (
      <div className="col-md-12 col-sm-12">
          <div className="switch-container">
            <span className="switch-field-placeholder">
              {item.title}
              <span
                className="info-tooltip"
                onClick={() => BindHelpText(item.HELP_TEXT)}
              >
                <img className="lbl-tooltip" src={InfoIcon} alt="" />
              </span>
              <label className="switch">
                <input
                  type="checkbox"
                  id={`service_${item.flag}`}
                  onChange={(e) =>
                    ToogleFlag(
                      item.flag,
                      item.visible,
                      item.adv_option_seq_num,
                      item.disable,
                      e
                    )
                  }
                  checked={isChecked}
                  disabled={item.disable}
                />
                <span className="slider round" />
              </label>
            </span>
          </div>
        </div>
    );
  };

  const accept = () => {
    setBoxes((boxesValue) => ({
      ...boxesValue,
      check: true,
    }));
    Confirm(true);
  };

  const reject = () => {
    $(`#service_${  toggleObj?.flag}`)[0].checked = false;
  };

  const BindHelpText = (text) => {
    setDetail(text);
    setPopup(true);
  };

  const ToogleFlag = (flag, visible, adv_option_seq_num, disable, e) => {
    let textMessage = "";
    if (visible === "N" || visible === "n" || visible === null) {
      textMessage = "Are you sure you want to turn on this flag?";
      visible = "Y";
    } else {
      visible = "N";
      textMessage = "Are you sure you want to turn off this flag?";
    }

    if (flag === "Email_Remainder_Activation") {
      if (EmailData.interval === "") {
        DisplayMsg("2", "Please fill the required field to on the toggle");
        return;
      }
    } else if (flag === "Call_Reminder_Activation") {
      if (CallData.interval === "") {
        DisplayMsg("2", "Please fill the required field to on the toggle");
        return;
      }
    }

    setToggleObj({
      visible,
      flag,
      e,
    });

    const {checked} = e.target;
    if (checked) {
      visible = "Y";
    } else {
      visible = "N";
    }

    setBoxes((boxesValue) => ({
      ...boxesValue,
      message: textMessage,
    }));
    setConfirm(true);
  };

  const Confirm = async (check) => {
    const { flag, e } = toggleObj;

    const handleToggleCheckbox = () => {
      if (e?.target?.checked === true) {
        e.target.checked = false;
      } else {
        e.target.checked = true;
      }
    };

    if (!check) {
      handleToggleCheckbox();
      return;
    }

    if (flag === "Email_Remainder_Activation") {
      const formData = new FormData();
      formData.append("EntitySeq_num", props.entityId); // sessionStorage["ENTITY_SEQ_NUM"]
      formData.append("PatientPortalURL", "");
      formData.append("CompanyName", "");
      formData.append("PracticeName", "");
      formData.append("DefaultMedicationUser", "");

      formData.append("DefaultLabUser", "");
      formData.append("RegistrationUser", "");
      formData.append("TNSName", sharedData.currentClientTnsName);
      document.getElementById("loader").style.display = "block";
      const result = await fetch(
        setUrl("PRACTICEDETAIL", "INACTIVATEEMAILREMAINDER", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const response = await result.json();
      if (response && response.status) {
        setEmailToggle((EmailInfo) => ({
          ...EmailInfo,
          disable: true,
        }));
        setEmailData((mailData) => ({
          ...mailData,
          interval: "",
          template: "Default",
          upload: false,
          EmailCheck: "N",
          filePath: "",
        }));
        DisplayMsg("1", response.Message);
        LoadServicesData();
      } else {
        DisplayMsg("2", response.Message);
      }
    } else if (flag === "Call_Reminder_Activation") {
      if (EmailData.interval === "") {
        DisplayMsg("2", "Please fill the required field to on the toggle");
        return;
      }

      document.getElementById("loader").style.display = "block";
      const formData = new FormData();
      formData.append("EntitySeq_num", props.entityId); // sessionStorage["ENTITY_SEQ_NUM"]
      formData.append("PatientPortalURL", "");
      formData.append("CompanyName", "");
      formData.append("PracticeName", "");
      formData.append("DefaultMedicationUser", "");

      formData.append("DefaultLabUser", "");
      formData.append("RegistrationUser", "");
      formData.append("TNSName", sharedData.currentClientTnsName);

      const result = await fetch(
        setUrl("PRACTICEDETAIL", "INACTIVATECALLREMAINDER", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const response = await result.json();
      if (response && response.status) {
        setCallData((CallInfo) => ({
          ...CallInfo,
          interval: "",
          CallCheck: "N",
        }));

        setCallToggle((callData) => ({
          ...callData,
          visible: "N",
          disable: true,
        }));

        DisplayMsg("1", response.Message);
        LoadServicesData();
      } else {
        DisplayMsg("2", response.Message);
      }
      // e.target.checked = false;
    }
  };

  const AlterServiceData = (event) => {
    const {name} = event.target;
    const curVal = event.target.value;
    switch (name) {
      case "template":
        if (curVal === "Default") {
          setEmailData((EmailInfo) => ({
            ...EmailInfo,
            upload: false,
          }));
        } else {
          setEmailData((EmailInfo) => ({
            ...EmailInfo,
            upload: true,
          }));

          setError((ErrInfo) => ({
            ...ErrInfo,
            FileErr: "",
          }));
        }
        setEmailData((EmailInfo) => ({
          ...EmailInfo,
          template: curVal,
        }));

        break;
      case "emailInterval":
        setEmailData((EmailInfo) => ({
          ...EmailInfo,
          interval: curVal,
        }));
        if (event.target.value.length < 1) {
          setError((ErrInfo) => ({
            ...ErrInfo,
            EmailErr: "Required",
          }));
        } else {
          setError((ErrInfo) => ({
            ...ErrInfo,
            EmailErr: "",
          }));
        }
        break;
      case "callInterval":
        setCallData((callInfo) => ({
          ...callInfo,
          interval: curVal,
        }));

        if (curVal.length < 1) {
          setError((ErrInfo) => ({
            ...ErrInfo,
            CallErr: "Required",
          }));
        } else if (isNaN(event.target.value) === true) {
          setError((ErrInfo) => ({
            ...ErrInfo,
            CallErr: "Invalid Number",
          }));
        } else {
          setError((ErrInfo) => ({
            ...ErrInfo,
            CallErr: "",
          }));
        }
        break;
      case "vendor":
        setCallData((callInfo) => ({
          ...callInfo,
          vendor: curVal,
        }));
        break;
      case "customTemplate":
        setEmailData((EmailInfo) => ({
          ...EmailInfo,
          file: event.target.files[0],
        }));

        setError((ErrInfo) => ({
          ...ErrInfo,
          FileErr: event.target.files.length > 0 ? "" : "Required",
        }));

        break;
      default:
        break;
    }
  };

  const CallRemainderSetup = async () => {
    let isvalid = true;
    if (CallData.interval.length === 0) {
      setError((ErrInfo) => ({
        ...ErrInfo,
        CallErr: "Required",
      }));
      isvalid = false;
    }

    if (Error.CallErr !== "") {
      isvalid = false;
    }

    if (isvalid) {
      document.getElementById("loader").style.display = "block";
      const formData = new FormData();
      formData.append("EntitySeq_num", props.entityId); // sessionStorage["ENTITY_SEQ_NUM"]
      formData.append("CustomerID", sharedData.currentClientId);
      formData.append("Interval", CallData.interval);
      formData.append("TNSName", sharedData.currentClientTnsName);
      formData.append("issaved", CallData.CallCheck);
      formData.append("Vendor", CallData.vendor);
      const result = await fetch(
        setUrl("PRACTICEDETAIL", "CALLREMAINDER", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const response = await result.json();
      if (response && response.status) {
        setCallToggle((callData) => ({
          ...callData,
          visible: "Y",
          disable: false,
        }));

        setCallData((callInfo) => ({
          ...callInfo,
          CallCheck: "Y",
        }));
        DisplayMsg("1", response.Message);
      } else {
        DisplayMsg("2", response.Message);
      }
    }
  };

  const EmailRemainderSetup = async () => {
    let isvalid = true;
    if (EmailData.interval.length === 0) {
      setError((ErrInfo) => ({
        ...ErrInfo,
        EmailErr: "Required",
      }));
      isvalid = false;
    }

    if (EmailData.upload && EmailData.file == null) {
      setError((ErrInfo) => ({
        ...ErrInfo,
        FileErr: "Required",
      }));
      isvalid = false;
    }

    let checkInterval = EmailData.interval;
    while (checkInterval.search(",", "") !== -1) {
      checkInterval = checkInterval.replace(",", "");
    }
    if (isNaN(checkInterval) === true) {
      setError((ErrInfo) => ({
        ...ErrInfo,
        EmailErr: "Invalid Number",
      }));
      isvalid = false;
    }
    if (isvalid) {
      document.getElementById("loader").style.display = "block";
      const formData = new FormData();
      formData.append(
        "custom_template",
        EmailData.file ? EmailData.file : undefined
      );

      formData.append("EntitySeq_num", props.entityId); // props.entityId
      formData.append("CustomerID", sharedData.currentClientId); // common.clientId
      formData.append("Interval", EmailData.interval);
      formData.append("TNSName", sharedData.currentClientTnsName); // sessionStorage["tnsName"]
      formData.append("issaved", EmailData.EmailCheck);
      formData.append("Template", EmailData.file ? "Custom" : "Default");
      const result = await fetch(
        setUrl("PRACTICEDETAIL", "EMAILREMAINDERSETUP", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const response = await result.json();
      if (response && response.status) {
        LoadServicesData();
        setEmailToggle((emailData) => ({
          ...emailData,
          visible: "Y",
          disable: false,
        }));
        setEmailData((mailData) => ({
          ...mailData,
          EmailCheck: "Y",
        }));
        DisplayMsg("1", response.Message);
      } else {
        DisplayMsg("2", response.Message);
      }
    }
  };

  const ValidateData = (event) => {
    const {name} = event.target;
    switch (name) {
      case "emailInterval":
        if (event.target.value.length < 1) {
          setError((ErrInfo) => ({
            ...ErrInfo,
            EmailErr: "Required",
          }));
        }
        break;
      case "callInterval":
        if (event.target.value.length < 1) {
          setError((ErrInfo) => ({
            ...ErrInfo,
            CallErr: "Required",
          }));
        }
        break;
      case "customTemplate":
        if (event.target.files.length < 1) {
          setError((ErrInfo) => ({
            ...ErrInfo,
            FileErr: "Required",
          }));
        }
        break;

      default:
        break;
    }
  };

  const CloseTooltip = () => {
    setDetail("");
    setPopup(false);
  };

  return (
    <>
      {popup && <TooltipText tooltip={detail} parentCallback={CloseTooltip} />}

      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="row table-panel-header mt-4 bg-white">
            <div className="col-md-12">
              <h6>Call / Text Reminder</h6>
            </div>
          </div>
          <div className="row">
            {ConfigrationSetup(callToggle, "CallRemainder")}
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Interval
                  <span className="redboxRequired" />
                </label>
                <input
                  type="text"
                  name="callInterval"
                  value={CallData.interval}
                  onChange={(e) => AlterServiceData(e)}
                  onFocus={(e) => ValidateData(e)}
                  className="field-input"
                  min={2}
                  max={2}
                />
              </div>
              <label className="requiredtext">{Error.CallErr}</label>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Vender Name:
                </label>
                <select
                  className="field-input"
                  value={CallData.vendor}
                  name="vendor"
                  onChange={(e) => AlterServiceData(e)}
                >
                  {Venders.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {SaveBtn && (
              <div className="col-md-12 col-sm-12 text-center">
                <input
                  type="button"
                  className="btnLinkGreen btnUpdate"
                  value="Save"
                  onClick={() => CallRemainderSetup()}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="row table-panel-header mt-4 bg-white">
            <div className="col-md-12">
              <h6>Email Reminder</h6>
            </div>
          </div>
          <div className="row">
            {ConfigrationSetup(emailToggle, "EmailRemainder")}
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Interval
                  <span className="redboxRequired" />
                </label>
                <input
                  type="text"
                  name="emailInterval"
                  value={EmailData.interval}
                  onChange={(e) => AlterServiceData(e)}
                  onFocus={(e) => ValidateData(e)}
                  className="field-input"
                  min={2}
                  max={2}
                />
              </div>
              {EmailData.file == null && (
                <label className="requiredtext">{Error.EmailErr}</label>
              )}
            </div>
            <div className="col-md-12 col-sm-12">
              <div className="field-container">
                <label className="field-placeholder font-medium">
                  Email Body Template:
                </label>
                <select
                  className="field-input"
                  value={EmailData.template}
                  name="template"
                  onChange={(e) => AlterServiceData(e)}
                >
                  {Templates.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {EmailData.upload && (
              <div className="col-md-12 col-sm-12 mb-2">
                <div className="field-container mb-0">
                  <label className="font-semibold label-top-text font-medium">
                    Company Template
                  </label>
                  <input
                    type="file"
                    onChange={(e) => AlterServiceData(e)}
                    className="field-input field-input-file"
                    name="customTemplate"
                    onFocus={(event) => ValidateData(event)}
                  />
                </div>
                {EmailData.template === "Custom" && EmailData.file == null && (
                  <div className="requiredtext">{Error.FileErr}</div>
                )}
                {EmailData.filePath !== "" && (
                  <span className="my-3">
                    <a href={EmailData.filePath} download="Email_template.html">
                      Click here to download linked template
                    </a>
                  </span>
                )}
              </div>
            )}
            {SaveBtn && (
              <div className="col-md-12 col-sm-12 text-center">
                <input
                  type="button"
                  className="btnLinkGreen btnUpdate"
                  value="Save"
                  onClick={() => EmailRemainderSetup()}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <ConfirmDialog
        visible={confirm}
        onHide={() => setConfirm(false)}
        message={Boxes.message}
        header="Please Confirm"
        accept={accept}
        reject={reject}
      />
    </>
  );
};

export default Services;
